import React from "react";

export function CustomizationAppearanceSection({ customization, handleChange, styles }) {
  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>Aparência</h3>

      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>
            Cor Primária:
            <input
              type="color"
              name="primary"
              value={customization.colors.primary}
              onChange={handleChange}
              style={styles.colorInput}
            />
          </label>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Cor Secundária:
            <input
              type="color"
              name="secondary"
              value={customization.colors.secondary}
              onChange={handleChange}
              style={styles.colorInput}
            />
          </label>
        </div>
      </div>

      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>
            Cor do Balão do Bot:
            <input
              type="color"
              name="botBubble"
              value={customization.colors.botBubble}
              onChange={handleChange}
              style={styles.colorInput}
            />
          </label>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Cor do Balão do Usuário:
            <input
              type="color"
              name="userBubble"
              value={customization.colors.userBubble}
              onChange={handleChange}
              style={styles.colorInput}
            />
          </label>
        </div>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          URL da Logo:
          <input
            type="text"
            name="logo"
            value={customization.logo}
            onChange={handleChange}
            placeholder="https://exemplo.com/logo.png"
            style={styles.input}
          />
        </label>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          URL do Favicon:
          <input
            type="text"
            name="favicon"
            value={customization.favicon}
            onChange={handleChange}
            placeholder="https://exemplo.com/favicon.ico"
            style={styles.input}
          />
        </label>
      </div>
    </div>
  );
}
